<template>
  <modal :modal-key="'paypal'" :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_paypal_purchase }} Paypal Purchase!</h1>
      <img class="usericon" src="static/images/cart.svg" alt="">
    </template>
    <template slot="body">
      <p class="modal_strong" v-if="!getBundleData.joker">
        {{ getBundleData.numberOfGames?getBundleData.numberOfGames + ' ' + getTranslations.home_modals_confirm_purchase_games:'' }}
        {{getBundleData.numberOfGames && getBundleData.points ?getTranslations.home_modals_confirm_purchase_and:'' }}
        {{ getBundleData.points?getBundleData.points + ' ' + getTranslations.home_modals_confirm_purchase_points:''}}
        – {{ getBundleData.price
        }} {{ getBundleData.currencyCode }}</p>

      <p v-if="!getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_playing_more }}</p>
      <p v-if="!getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_are_you_sure_you_want_to_continue }}</p>
    </template>
    <template slot="footer">
      <div id="paypal-button-container"></div>
    </template>
  </modal>
</template>

<script>
/* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import FailedPurchase from './PaypalFailedPurchase';
import ConfirmPurchaseSuccessful from './PaypalConfirmPurchase';
import axios from "axios";
import auth from "../../../../common/auth";

export default {
  name: 'confirmPurchase',
  components: {
    Modal,
  },
  data() {
    return {
      buttonEnabled: true,
    };
  },
  mounted() {
    console.log('PayPal SDK loaded successfully');
    this.initPayPalButtons();
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
      'chargePinCall',
    ]),
    purchaseBundle() {
      this.buttonEnabled = false;
      this.getUserLoginDetails().then(() => {
        const bundleInfo = {
          bundleId: this.bundleId,
          pin: null,
        };
        this.chargePinCall({ value: bundleInfo }).then(() => {
          this.buttonEnabled = true;
          if (this.chargePinResponse === 'OPERATION_SUCCESS') {
            this.$emit('bundlePurchase');
            this.storeModalForStore(ConfirmPurchaseSuccessful);
          } else if (this.chargePinResponse === 'NO_BALANCE') {
            this.storeModalForStore(FailedPurchase);
          }
        });
      });
    },
    initPayPalButtons() {
      paypal.Buttons({
        style: {
          color: 'gold',
          shape: 'pill',
        },
        createOrder: () => {
          const currencyCode = this.getBundleData.currencyCode;
          const value = this.getBundleData.price;
          const bundleId = this.bundleId;
          return axios({
            url: `api/createOrder?currencyCode=${currencyCode}&value=${value}&bundleId=${bundleId}`,
            method: 'GET',
            headers: {
              Authorization: auth.getJwt(),
            },
          }).then((response) => {
            this.orderId = response.data.data.orderId;
            console.log(this.orderId);
            return response.data.data.orderId;
          });
        },
        onApprove: () => {
          const bundleId = this.bundleId;
          return axios({
            url: `api/captureOrder?orderId=${this.orderId}&bundleId=${bundleId}`,
            method: 'GET',
            headers: {
              Authorization: auth.getJwt(),
            },
          }).then((response) => {
            try {
              const responseObj = JSON.parse(response.data.data.responseJSON);
              const status = responseObj.status;
              console.log("Status:", status);
              this.storeModalForStore(ConfirmPurchaseSuccessful);

            } catch (error) {
              console.error("Error parsing JSON:", error);
              this.storeModalForStore(FailedPurchase);

            }
            response.data.data
          });
        },
        onError: (err) => {
          this.storeModalForStore(FailedPurchase);
          console.error(err);
        },
      }).render('#paypal-button-container');
    },
  },
  computed: {
    ...mapState('profile', [
      'chargePinResponse',
      'bundleId',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/paypal/Paypal.vue